import { IconDots } from '@iwoca/icons';
import { Button } from '@iwoca/orion';

export const ActionsCell = () => {
  // TODO BF-80: row actions menu (edit / deactivate / change permissions)
  return (
    <Button variant="tertiary" iconOnly aria-label="Row actions">
      <IconDots />
    </Button>
  );
};
